import { ArrowSwitcher } from "./arrow-switcher/arrow-switcher";
import { StyledCalendarContainer, StyledCalendar } from "./calendar.style";

import { LowerMenuBar } from "./lower-menu-bar/lower-menu-bat";
import { Table } from "./table/table";

const Calendar = () => {
  return (
    <StyledCalendarContainer>
      <StyledCalendar>
        <ArrowSwitcher />
        <Table />
      </StyledCalendar>

      <LowerMenuBar />
    </StyledCalendarContainer>
  );
};

export default Calendar;
